import { render, staticRenderFns } from "./viewCompletework.vue?vue&type=template&id=5c1521de&scoped=true"
import script from "./viewCompletework.vue?vue&type=script&lang=js"
export * from "./viewCompletework.vue?vue&type=script&lang=js"
import style0 from "./viewCompletework.vue?vue&type=style&index=0&id=5c1521de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1521de",
  null
  
)

export default component.exports